import { jwtDecode, type JwtPayload } from "jwt-decode";
import moment, { Moment } from "moment";

export interface UserAuthTokenJSON {
  _value: string;
  _data: JwtPayload;
  _expiry: string;
}

export default class UserAuthToken {
  _value: string;
  _data: JwtPayload;
  _expiry: Moment;

  constructor(value: string, expiry: Moment) {
    this._value = value;
    this._data = jwtDecode(value);
    this._expiry = expiry;
  }

  public get isExpired(): boolean {
    return this._expiry.isBefore();
  }

  public get value(): string {
    return this._value;
  }

  public static fromJSON(json: UserAuthTokenJSON) {
    return new UserAuthToken(json._value, moment(json._expiry));
  }

  public toJSON(): UserAuthTokenJSON {
    return {
      _value: this._value,
      _data: this._data,
      _expiry: this._expiry.toISOString(),
    };
  }
}
